import type { ReactNode } from "react";
import { useTranslate } from "ra-core";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

import { useListView } from "./useListView";

export interface ListViewOption<View extends string> {
  value: View;
  icon: ReactNode;
  label: string;
}

/** Icon buttons to switch a list between its views (e.g. table / cards, Kanban / list). */
export const ListViewToggle = <View extends string>({
  storeKey,
  defaultView,
  options,
}: {
  storeKey: string;
  defaultView: View;
  options: ListViewOption<View>[];
}) => {
  const translate = useTranslate();
  const [view, setView] = useListView(storeKey, defaultView);
  return (
    <ToggleGroup
      type="single"
      variant="outline"
      size="sm"
      value={view}
      onValueChange={(value) => value && setView(value as View)}
    >
      {options.map((option) => (
        <ToggleGroupItem
          key={option.value}
          value={option.value}
          aria-label={translate(option.label)}
          title={translate(option.label)}
        >
          {option.icon}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
};
